<template>

<div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="场馆信息" name="first">
            <el-form
            ref="addForm"
            :model="addForm"
            :rules="rulesAddForm"
            label-width="105px">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="项目名称">
                            <el-select
                            v-model="addForm.projectId"
                            placeholder="项目名称"
                            style="width: 100%"
                            @change="(value) => projectChange(value, 1)"
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="区域名称">
                            <el-select
                                @change="(value) => areaChange(value, 1)"
                                v-model="addForm.areaId"
                                placeholder="区域名称"
                                style="width: 100%">
                                <el-option
                                    v-for="item in areaList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="场馆类型">
                            <el-select
                                @change="(value) => typeChange(value, 1)"
                                v-model="addForm.type" placeholder="场馆类型" style="width: 100%">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.dictKey"
                                    :label="item.dictValue"
                                    :value="item.dictKey"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="场馆名称">
                            <el-select
                            @change="venueNameChange" v-model="addForm.venueId" placeholder="活动区域">
                                <el-option
                                    v-for="item in venueNameList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="申请公司" required prop="applyCompany">
                            <el-input v-model="addForm.applyCompany" maxlength="30" placeholder="申请公司">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="申请人" required prop="applyName">
                            <el-input v-model="addForm.applyName" maxlength="30" placeholder="申请人">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item required label="申请人手机" prop="applyPhone">
                            <el-input v-model="addForm.applyPhone" placeholder="申请人手机">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="证件号">
                            <el-input v-model="addForm.applyCertNo" placeholder="证件号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="到场人数">
                            <el-input v-model="addForm.attendance" maxlength="5" placeholder="活动区域">

                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="申请时间" required prop="applyTime">
                            <el-input
                            disabled v-model="addForm.applyTime" placeholder="活动区域">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item required label="选择日期">
                            <el-date-picker
                            @change="dayChange"
                            value-format="yyyy-MM-dd"
                            v-model="day"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions0">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item required label="开始时间">
                                <el-time-select
                                @change="startTimeChange"
                                style="width: 100%"
                                placeholder="开始时间"
                                v-model="startTime"
                                :picker-options="{
                                    start: '00:30',
                                    step: '00:30',
                                    end: '23:30',
                                }"
                                >
                                </el-time-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item required label="结束时间">
                            <el-time-select
                            @change="endTimeChange"
                            style="width: 100%"
                            placeholder="结束时间"
                            v-model="endTime"
                            :picker-options="{
                                start: '00:30',
                                step: '00:30',
                                end: '23:30',
                                minTime: startTime,
                            }"
                            >
                            </el-time-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item required label="场馆租金(元)">
                            <el-input disabled v-model="addForm.venueAmount" placeholder="场馆租金(元)">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item required label="服务费总额(元)">
                            <el-input disabled v-model="addForm.serviceAmount" placeholder="服务费总额(元)">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item required label="费用总额(元)">
                            <el-input disabled v-model="addForm.totalAmount" placeholder="费用总额(元)">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                        <el-form-item label="备注说明">
                            <el-input v-model="addForm.description" placeholder="备注">
                            </el-input>
                        </el-form-item>
                </el-row>
                <el-row>
                        <el-form-item label="服务项">
                            <el-checkbox-group v-model="checkList" @change="handleCheckedChange">
                                <el-checkbox v-for="(item,index) in serviceConfigList" :disabled="item.requiredFlag" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                </el-row>
                <el-row>
                        <el-form-item label="" label-width="0px">
                            <el-table
                                :data="tempConfigList"
                                border
                                style="width: 100%">
                                <el-table-column
                                fixed
                                type="index"
                                width="50">
                                </el-table-column>
                                <el-table-column
                                prop="projectName"
                                label="项目名称"
                                width="150">
                                </el-table-column>
                                <el-table-column
                                prop="chargeTypeName"
                                label="收费方式"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                label="服务名称"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="feeName"
                                label="服务费"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="description"
                                label="服务说明"
                                width="300">
                                </el-table-column>
                            </el-table>

                            <el-pagination
                            @size-change="handleConfigSizeChange"
                            @current-change="handleConfigCurrentChange"
                            :current-page="configPage.currentPage"
                            :page-sizes="[10]"
                            :page-size="configPage.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="configPage.total">
                            </el-pagination>
                        </el-form-item>
                </el-row>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="人员信息" name="second">
            <el-form :model="userForm" ref="userForm" :rules="rules" label-width="105px">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required label="姓名" prop="name">
                            <el-input v-model="userForm.name" placeholder="姓名">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required label="电话" prop="phone">
                            <el-input v-model="userForm.phone" placeholder="电话">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="证件号">
                            <el-input v-model="userForm.certNo" placeholder="证件号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车牌号">
                            <el-input v-model="userForm.plateNo" placeholder="车牌号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="24">
                    <el-form-item label="" label-width="1px">
                        <div style="text-align:center;">
                        <el-button @click="addUser('userForm')" type="primary" size="small" icon="el-icon-plus">添加</el-button>
                        </div>
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="" label-width="5px">
                            <el-table
                                height="250"
                                :data="tempUserList"
                                border
                                style="width: 100%;">
                                <el-table-column
                                prop="name"
                                label="姓名"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="phone"
                                label="电话"
                                width="150">
                                </el-table-column>
                                <el-table-column
                                prop="certNo"
                                label="证件号"
                                width="">
                                </el-table-column>
                                <el-table-column
                                prop="plateNo"
                                label="车牌号"
                                width="">
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="100">
                                <template slot-scope="scope">
                                    <el-button @click="userDelActionClick(scope)" type="danger" size="small">删除</el-button>
                                </template>
                                </el-table-column>
                            </el-table>

                            <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.currentPage"
                            :page-sizes="[10]"
                            :page-size="page.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                            </el-pagination>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-tab-pane>
    </el-tabs>
        <div v-if="activeName==='first'" slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click="$emit('addClose','cancel')">关 闭</el-button>
            <el-button type="primary" @click.native.prevent="nextStepFunc">下一步</el-button>
        </div>
        <div v-if="activeName==='second'" slot="footer" class="dialog-footer" style="text-align:center">
            <el-button type="primary" @click.native.prevent="activeName='first'">上一步</el-button>
            <el-button @click="$emit('addClose','cancel')">关 闭</el-button>
            <el-button type="primary" @click.native.prevent="submitFormData">确 定</el-button>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import {getServiceConfigList,getAllServiceConfigList,getVenueChargeTypeList,getAreaList,getVenueNameList,getVenueFee,add} from '@/api/v4ward/stadium-management/apply';
export default {
    props:['dialogFormVisibleAdd','addForm','projectList','areaList','typeList','venueList'],
    data(){
        return{
            page:{
                currentPage:1,
                size:10,
                total:0
            },
            configPage:{
                currentPage:1,
                size:10,
                total:0
            },
            tempUserList:[],
            tempConfigList:[],
            pickerOptions0: {
         disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
         }
    },
    day:'',
    startTime:'',
    endTime:'',
    venueServiceConfigIds:'',
    serviceConfig:[],
        venueNameList:[],
        checkList:[],
        serviceConfigList:[],
        venueChargeTypeList:[],
        attendancePattern:/^[1-9]\d*$/,
        certNoPattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
        plateNoPattern:/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]{1}([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}))$/,
        phonePattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
        rulesAddForm:{
            name: [
                { required: true, message: '请输入活动名称', trigger: 'blur' },
            ],
            applyPhone: [
                { required: true, message: '请输入申请人手机号', trigger: 'change' },
                { required: true, message: '请输入申请人手机号', trigger: 'blur' },
                { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' }
            ],
            createTime:[
                { required: true, message: '请输入申请时间', trigger: 'blur' },
            ],
            applyCompany:[
                {
                    required: true, message: '请输入申请公司', trigger: 'change'
                },
                {
                    required: true, message: '请输入申请公司', trigger: 'blur'
                }
            ],
            applyName:[
                { required: true, message: '请输入申请人', trigger: 'change' },
                { required: true, message: '请输入申请人', trigger: 'blur' },
            ]
       },
        rules: {
            name: [
                { required: true, message: '请输入姓名', trigger: 'blur' },
                { required: true, message: '请输入姓名', trigger: 'change' },
            ],
            phone: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                { required: true, message: '请输入手机号', trigger: 'change' },
                { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' }
            ],
            certNo: [
                {
                    pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '证件号格式错误',trigger: 'change'
                }
            ],

        },
            activeName:'first',
            addUserList:[],
            userForm:{}
        }
    },
    mounted(){
        console.log(this.addForm);
        console.log("this.venueList====>",this.venueList);
        console.log("this.projectList====>",this.projectList);
        this.addForm = Object.assign({},this.addForm,{
        });
        this.handleConfigPageAction();
    },
    methods:{
        nextStepFunc(){
            let self = this;
            console.log(self.startTime,self.endTime);
            console.log(self.day+' '+self.startTime)
            let timeStart = Date.parse(self.day+' '+self.startTime)
            let timeEnd = Date.parse(self.day+' '+self.endTime)
            console.log("nextStepFunc======>",timeEnd,timeStart);
            if(timeStart>timeEnd){
                    this.$message.error('结束时间必须大于开始时间！');
                return;
            }
            this.activeName = 'second';
        },
        testFormData(value,reg){
            return reg.test(value);
        },
        getAddFormData(){
            let self = this;
            this.addForm = Object.assign({},this.addForm,{
                startTime:self.day+' '+self.startTime,
                endTime:self.day+' '+self.endTime,
                serviceConfigIds:self.venueServiceConfigIds||'',
                applyMembers:self.addUserList||'',
            })
        },
        submitFormData(){
            if(this.addForm.attendance&&((this.addForm.attendance+'')!=='undefined')){
                let testAttendanceFlag = this.testFormData(this.addForm.attendance,this.attendancePattern);
                if(!testAttendanceFlag){
                    this.$message.error('到场人数格式错误！');
                    return;
                }
            }
            if(this.addForm.applyCertNo&&((this.addForm.applyCertNo+'')!=='undefined')){
                let testCertNoFlag = this.testFormData(this.addForm.applyCertNo,this.certNoPattern);
                if(!testCertNoFlag){
                    this.$message.error('证件号格式错误！');
                    return;
                }
            }
            if(this.addForm.applyPhone&&((this.addForm.applyPhone+'')!=='undefined')){
                let testPlateNoFlag = this.testFormData(this.addForm.applyPhone,this.phonePattern);
                if(!testPlateNoFlag){
                    this.$message.error('手机号格式错误！');
                    return;
                }
            }
            console.log(this.addForm);

            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.getAddFormData();
                    add(this.addForm).then((res)=>{
                        this.$message.success('操作成功!');
                        this.dialogFormVisibleAdd = false;
                        this.$emit('addClose','submit');
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        dayChange(val){
            this.triggerGetVenueFee();
        },
        endTimeChange(val){
            this.triggerGetVenueFee();
        },
        startTimeChange(val){
            this.triggerGetVenueFee();
        },
        resetFormData(venueNameList,dateInfo){
            // this.addForm = {};
            let self = this;
            this.checkList = [];
            this.serviceConfigList = [];
            // console.log(new Date(dateInfo.end));
            setTimeout(()=>{
                this.addForm.applyTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                this.day = dayjs(dateInfo.start).format('YYYY-MM-DD');
                this.startTime = dayjs(dateInfo.start).format('HH:mm');
                this.endTime = dayjs(dateInfo.end).format('HH:mm');
            })
            getVenueChargeTypeList().then(({data})=>{
                this.venueChargeTypeList = data;
            });
            // getVenueNameList(this.addForm).then((res)=>{
            getAreaList({ projectId: self.addForm.projectId }).then(({ data }) => {
                this.areaList = data;
                this.venueNameList = venueNameList;
                this.venueNameChange(self.addForm.venueId);

                this.triggerGetVenueList(1);
                // this.addForm.areaId = data[0].id;
                // this.addForm.type = this.typeList[0].dictKey;
            });
            // })
        },
      areaChange(value,type){
        if(type){
          this.addForm = Object.assign({},this.addForm,{
            areaId:value
          });
        }
        this.triggerGetVenueList();
      },
      typeChange(value){
        this.addForm = Object.assign({},this.addForm,{
          type:value
        });
        this.triggerGetVenueList();
      },
      triggerGetVenueList(type){
        console.log("<=======triggerGetVenueList=======>");
        if(this.addForm.areaId&&this.addForm.projectId&&this.addForm.type){
            if(type){
                this.venueNameList = [];
                // this.addForm.venueId = '';
            }else{
                this.venueNameList = [];
                this.addForm.venueId = '';
            }
          getVenueNameList({areaId:this.addForm.areaId,projectId:this.addForm.projectId,type:this.addForm.type}).then((res)=>{
            console.log(res);
            this.venueNameList = res.data;
          });
        }
      },

      triggerGetVenueFee(type){
          console.log("triggerGetVenueFee========>",this.checkList);

        // if(
        //     this.checkList&&this.checkList.length==0
        // ){
        //     this.addForm = Object.assign({},this.addForm,{
        //         totalAmount:0,
        //         serviceAmount:0,
        //         venueAmount:0
        //     })
        //     return;
        // }
        if(
            this.checkList&&this.checkList.length>0
        ){
            this.venueServiceConfigIds = this.checkList.join(',');
        }else{
            this.venueServiceConfigIds = '';
        }
        console.log((this.addForm.venueId&&this.day&&this.startTime&&this.endTime&&this.venueServiceConfigIds));
        if(this.addForm.venueId&&this.day&&this.startTime&&this.endTime
        // &&this.venueServiceConfigIds
        ){
            this.venueFeeObject = {};
            getVenueFee({
                venueId:this.addForm.venueId,
                day:this.day,
                startTime:this.startTime,
                endTime:this.endTime,
                venueServiceConfigIds:this.venueServiceConfigIds||''
                }).then((res)=>{
                    console.log(res);
                    this.venueFeeObject = res.data;
                    this.addForm.venueAmount = res.data.venueRent;
                    this.addForm.serviceAmount = res.data.serviceFee;
                    this.addForm.totalAmount = res.data.totalFee;
                    this.addForm = Object.assign({},this.addForm,{
                        totalAmount:res.data.totalFee,
                        serviceAmount:res.data.serviceFee,
                        venueAmount:res.data.venueRent
                    })
            });
        }
      },
    projectChange(value, type) {
        this.addForm.areaId = '';
        this.addForm.venueId = '';
        this.addForm.type = '';
        this.addForm = Object.assign({},this.addForm,{
          projectId:value,
          venueId:''
        });
        getAreaList({ projectId: value }).then(({ data }) => {
            console.log('getAreaList=====>', data);
            this.areaList = data;
        });
        this.venueNameList = [];

            this.serviceConfig = [];
            this.serviceConfigList = [];
            this.checkList = [];
            this.handleConfigPageAction();
        this.triggerGetVenueList();
        this.$forceUpdate();
    },
        handleCheckedChange(value){
            console.log(value);
            this.serviceConfig = [];
            value.forEach((ele_)=>{
                this.serviceConfigList.forEach((ele,index)=>{
                    if(ele_===ele.id){
                        this.serviceConfig.push(ele);
                    }
                });
            });
            this.handleConfigPageAction();
            this.resetConfigList();
            this.triggerGetVenueFee();
        },
        resetConfigList(){
            let self = this;
            this.serviceConfig.forEach((ele)=>{
                if(ele.chargeType==1){
                    ele.feeName = ele.fee;
                }else{
                    ele.feeName = ele.fee+'%';
                }
                self.venueChargeTypeList.forEach((ele_)=>{
                    if(ele.chargeType === ele_.dictKey){
                        ele.chargeTypeName = ele_.dictValue;
                    }
                })
            });
        },
        venueNameChange(val){
            this.serviceConfig = [];
            this.checkList = [];
            let self = this;
            getAllServiceConfigList({venueId:val}).then(({ data })=>{
                console.log(data);
                self.serviceConfigList = data;
                data.forEach((ele)=>{
                    if(parseInt(ele.requiredFlag) == 1){
                        self.checkList.push(ele.id)
                        console.log(ele);
                    }
                });
                        setTimeout(()=>{
                            self.handleCheckedChange(self.checkList);
                        })
            });
        },
        validatePhone(){

        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        userDelActionClick(row){
            console.log(row);
            this.addUserList.splice(row.$index,1);
            this.handlePageAction();
        },
        checkAddUserRepeat(form){
            let repeatFlag = false;
            console.log(form);
            this.addUserList.forEach((ele)=>{
                console.log(ele,form);
                console.log(form.phone&&(ele.phone === form.phone));
                console.log(form.plateNo&&(form.plateNo+''!=='undefined')&&(ele.plateNo === form.plateNo));
                console.log(form.certNo&&(form.certNo+''!=='undefined')&&(ele.certNo === form.certNo));
                if(form.phone&&(ele.phone === form.phone)){
                    repeatFlag = true;
                }
            });
            console.log(repeatFlag);
            return repeatFlag;
        },
        handlePageAction(){
            let self = this;
            this.page.total = this.addUserList.length;
            let startIndex = (self.page.currentPage-1)*self.page.size;
            this.tempUserList = this.addUserList.slice(startIndex,startIndex+self.page.size);
        },
        handleCurrentChange(val){
            console.log(this.page);
            this.page.currentPage = val;
            this.handlePageAction();
        },
        handleSizeChange(val){
            console.log(this.page);
            this.page.size = val;
            this.handlePageAction();
        },
        handleConfigPageAction(){
            let self = this;
            this.configPage.total = this.serviceConfig.length;
            let startIndex = (self.configPage.currentPage-1)*self.configPage.size;
            this.tempConfigList = this.serviceConfig.slice(startIndex,startIndex+self.configPage.size);
        },
        handleConfigCurrentChange(val){
            console.log(this.configPage);
            this.configPage.currentPage = val;
            this.handleConfigPageAction();
        },
        handleConfigSizeChange(val){
            console.log(this.configPage);
            this.configPage.size = val;
            this.handleConfigPageAction();
        },
        addUser(formName){
            let self = this;
            if(this.userForm.certNo&&((this.userForm.certNo+'')!=='undefined')){
                let testCertNoFlag = this.testFormData(this.userForm.certNo,this.certNoPattern);
                if(!testCertNoFlag){
                    this.$message.error('证件号格式错误！');
                    return;
                }
            }
            if (this.userForm.plateNo && ((this.userForm.plateNo + '') !== 'undefined')) {
                let testPlateNoFlag = this.testFormData(this.userForm.plateNo,this.plateNoPattern);
                if(!testPlateNoFlag){
                    this.$message.error('车牌号格式错误！');
                    return;
                }
            }
            this.$refs.userForm.validate((valid) => {
                if (valid) {
                    let repeatFlag = self.checkAddUserRepeat(self.userForm);
                    console.log(repeatFlag);
                    if(!repeatFlag){
                        self.addUserList.push({
                            name:self.userForm.name,
                            phone:self.userForm.phone,
                            certNo:self.userForm.certNo,
                            plateNo:self.userForm.plateNo
                        });
                            self.handlePageAction();
                            self.userForm = {};
                        setTimeout(()=>{
                            self.$refs.userForm.clearValidate();
                        })
                    }else{
                        self.$message.error('请勿重复添加人员！');
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    }
}
</script>
<style lang="scss" scoped>
    ::v-deep .el-date-editor{
        width: 100%!important;
    }
</style>
